import "../styles/footer.css";
import { Link } from "react-router-dom";
import { useLanguage } from "../utils/LanguageContext";
import { ROUTES } from '../routes/path';

// Real contact details and social profiles. Anything left empty is hidden,
// so the footer never shows placeholder numbers or links that go nowhere.
const CONTACT = {
  address: 'Gulistan, Uzbekistan',
  email: 'info@novda.uz',
  phone: '',
};
const SOCIAL_LINKS = [
  { label: 'Telegram', icon: 'fab fa-telegram-plane', url: '' },
  { label: 'Instagram', icon: 'fab fa-instagram', url: '' },
  { label: 'Facebook', icon: 'fab fa-facebook-f', url: '' },
  { label: 'LinkedIn', icon: 'fab fa-linkedin-in', url: '' },
].filter(s => s.url);

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="site-footer">
      <div className="footer-cta" data-reveal="scale">
        <div className="footer-cta-glow" aria-hidden="true" />
        <div className="footer-cta-text">
          <span className="footer-cta-eyebrow"><i className="fas fa-leaf" /> {t('main_hero_badge')}</span>
          <h3>{t('main_hero_title_1')} <span className="serif-accent">{t('main_hero_title_2')}</span></h3>
        </div>
        <Link to={`/${ROUTES.SHOP}`} className="footer-cta-btn">
          <i className="fas fa-seedling" /> {t('main_btn_start')}
          <i className="fas fa-arrow-right footer-cta-arrow" />
        </Link>
      </div>

      <div className="footer-grid">
        <div className="footer-section footer-brand">
          <Link to="/" className="footer-logo">
            <span className="footer-logo-mark"><i className="fas fa-seedling" /></span>
            <span>EcoNovda<span className="footer-logo-dot">.</span></span>
          </Link>
          <p>{t('foot_desc')}</p>
          {SOCIAL_LINKS.length > 0 && (
            <div className="social-links">
              {SOCIAL_LINKS.map(link => (
                <a key={link.label} href={link.url} className="social-link" aria-label={link.label} target="_blank" rel="noreferrer">
                  <i className={link.icon} />
                </a>
              ))}
            </div>
          )}
        </div>
        <div className="footer-section">
          <h4>{t('foot_links')}</h4>
          <ul className="footer-links">
            <li>
              <Link to="/">{t('nav_home')}</Link>
            </li>
            <li>
              <Link to={`/${ROUTES.SHOP}`}>{t('nav_shop')}</Link>
            </li>
            <li>
              <Link to={`/${ROUTES.MAP}`}>{t('nav_map')}</Link>
            </li>
            <li>
              <Link to={`/${ROUTES.COMMUNITY}`}>{t('nav_community')}</Link>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>{t('foot_services')}</h4>
          <ul className="footer-links">
            <li>
              <Link to={`/${ROUTES.SHOP}`}>{t('foot_svc_plant')}</Link>
            </li>
            <li>
              <Link to={`/${ROUTES.MAP}`}>{t('foot_svc_track')}</Link>
            </li>
            <li>
              <Link to={`/${ROUTES.SHOP}`}>{t('foot_svc_gift')}</Link>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>{t('foot_contact')}</h4>
          <ul className="footer-links footer-contact">
            {CONTACT.address && <li><i className="fas fa-location-dot" /> {CONTACT.address}</li>}
            {CONTACT.email && (
              <li><i className="fas fa-envelope" /> <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
            )}
            {CONTACT.phone && (
              <li><i className="fas fa-phone" /> <a href={`tel:${CONTACT.phone.replace(/\s/g, '')}`}>{CONTACT.phone}</a></li>
            )}
          </ul>
        </div>
      </div>
      <div className="copyright">
        <span>© {new Date().getFullYear()} {t('foot_rights')}</span>
        <Link to={`/${ROUTES.PRIVACY_POLICY}`} className="copyright-link">{t('foot_privacy')}</Link>
      </div>
    </footer>
  );
};
